import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "fixed z-[999] w-full bottom-0 left-0 right-0 border border-greyScale-100 bg-greyScale-50 pt-2 md:pt-6 md:pb-4 rounded-t-xl" }
const _hoisted_2 = { class: "Container flex flex-col-reverse md:flex-row items-center justify-between" }
const _hoisted_3 = { class: "hidden md:block" }
const _hoisted_4 = { class: "hidden md:block h5 !font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "flex items-center mt-2 md:mt-0 justify-start gap-x-2 text-[12px] leading-[21px] md:leading-[26px] md:text-base" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "hidden md:block",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    fill: "#78788F",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8,0 C3.582,0 0,3.582 0,8 C0,12.419 3.582,16 8,16 C12.418,16 16,12.419 16,8 C16,3.582 12.418,0 8,0 Z M8.7225,11.415 L8.868,11.6805 C8.868,11.6805 8.224,12.943 7.146,12.943 C6.575,12.943 6.289,12.5785 6.289,11.85 C6.289,11.3285 6.427,10.5885 6.7015,9.633 C6.9755,8.675 7.1135,8.041 7.1135,7.7285 C7.1135,7.448 6.982,7.259 6.7175,7.162 L6.7985,6.784 C6.7985,6.784 7.736,6.0875 8.438,6.0875 C8.934,6.0875 9.182,6.356 9.182,6.895 C9.182,7.154 9.067,7.7165 8.8345,8.5845 C8.646,9.28 8.5035,9.849 8.407,10.2895 C8.326,10.651 8.286,10.899 8.286,11.0345 C8.286,11.288 8.4315,11.415 8.7225,11.415 Z M8.6125,5.255 C8.005,5.255 7.5125,4.765 7.5125,4.1575 C7.5125,3.55 8.0045,3.057 8.6125,3.057 C9.219,3.057 9.711,3.55 9.711,4.1575 C9.711,4.765 9.219,5.255 8.6125,5.255 Z",
      id: "Shape"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block font-semibold text-[14px]" }, "99% pacjentów rekomenduje nasze usługi")
], -1)
const _hoisted_6 = { class: "w-full md:max-w-[360px]" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_8 = { class: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" }
const _hoisted_9 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row items-center justify-center gap-x-6 lg:gap-x-4 pb-1 pt-[2px]\"><div class=\"flex items-center justify-center text-secondary text-[12px] font-semibold leading-6\"><span class=\"w-[16px] h-[16px] rounded-full flex items-center justify-center bg-secondary/20 mr-1\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"18\" viewBox=\"0 0 18 21\" fill=\"none\"><path d=\"M17.1358 11.8874V5.30234C17.1312 4.36569 16.5738 3.52017 15.7149 3.14661L12.8902 1.91278C10.2916 0.783344 7.34076 0.783344 4.74214 1.91278L1.92098 3.14661C1.05973 3.52118 0.501945 4.3701 0.5 5.30927V11.8943C0.500256 13.8538 1.4268 15.6979 2.99884 16.8677L7.11621 19.9315C8.12532 20.6819 9.50706 20.6819 10.5162 19.9315L14.6335 16.8677C16.2088 15.6972 17.137 13.8499 17.1358 11.8874Z\" fill=\"#17DE81\"></path><path d=\"M13.5064 7.48796C13.9741 7.95572 13.9741 8.7141 13.5064 9.18186L8.93475 13.7535C8.6017 14.0869 8.16461 14.2925 7.69972 14.3387L7.49899 14.3487C6.96038 14.3487 6.44387 14.1345 6.06341 13.7536L4.4937 12.1839C4.02594 11.7162 4.02594 10.9578 4.4937 10.49C4.96146 10.0223 5.71984 10.0223 6.18759 10.49L7.4963 11.8036L11.8125 7.48796C12.2802 7.02021 13.0386 7.02021 13.5064 7.48796Z\" fill=\"white\"></path></svg></span><p class=\"font-semibold text-secondary text-[12px]\">Bezpieczne płatności</p></div><div class=\"flex items-center justify-center text-secondary text-[12px] font-semibold leading-6\"><span class=\"w-[16px] h-[16px] rounded-full flex items-center justify-center bg-secondary/20 mr-1\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"18\" viewBox=\"0 0 18 21\" fill=\"none\"><path d=\"M17.1358 11.8874V5.30234C17.1312 4.36569 16.5738 3.52017 15.7149 3.14661L12.8902 1.91278C10.2916 0.783344 7.34076 0.783344 4.74214 1.91278L1.92098 3.14661C1.05973 3.52118 0.501945 4.3701 0.5 5.30927V11.8943C0.500256 13.8538 1.4268 15.6979 2.99884 16.8677L7.11621 19.9315C8.12532 20.6819 9.50706 20.6819 10.5162 19.9315L14.6335 16.8677C16.2088 15.6972 17.137 13.8499 17.1358 11.8874Z\" fill=\"#17DE81\"></path><path d=\"M13.5064 7.48796C13.9741 7.95572 13.9741 8.7141 13.5064 9.18186L8.93475 13.7535C8.6017 14.0869 8.16461 14.2925 7.69972 14.3387L7.49899 14.3487C6.96038 14.3487 6.44387 14.1345 6.06341 13.7536L4.4937 12.1839C4.02594 11.7162 4.02594 10.9578 4.4937 10.49C4.96146 10.0223 5.71984 10.0223 6.18759 10.49L7.4963 11.8036L11.8125 7.48796C12.2802 7.02021 13.0386 7.02021 13.5064 7.48796Z\" fill=\"white\"></path></svg></span><p class=\"font-semibold text-secondary text-[12px]\">Szybka realizacja</p></div></div>", 1)

import { formatPrice } from '../../helpers/formatPrice';


export default {
  __name: 'AddToCartButton',
  props: {
    price: {
        type: String,
        required: true,
    },
    isSubmitting: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.title), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: _normalizeClass(["Button w-full md:max-w-[400px] py-4 relative", { 'is-submitting': __props.isSubmitting }])
        }, [
          (!__props.isSubmitting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Zamawiam za " + _toDisplayString(_unref(formatPrice)(__props.price)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_8, [
            (__props.isSubmitting)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _hoisted_13
      ])
    ])
  ]))
}
}

}